import { server, services } from "../db/api";

export const createService = async (body) => {
  const request = await fetch(`${server}${services}/create-service-web`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  const response = await request.json();
  return response;
  
};

export const getServices = async (id) => {
  const request = await fetch(`${server}${services}/getServiceClient/${id}`, {
    method: "GET",
    headers: { "content-type": "application/json" },
  });
  const response = await request.json();
  return response;

};

export const getCategorias = async () => {
  const request = await fetch(`${server}/categorie/get-categorie`,
  {
    method: "GET",
    headers: { "content-type": "application/json" },
  })
  const response = await request.json()
  return response;
}

export const changeStatusServicio = async (body) => {
  const request = await fetch(`${server}${services}/services/changestatus`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  const response = await request.json();
  return response;
 


}